






































































































import { Component, Watch } from 'vue-property-decorator';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule'
import ProductIssue from '@/models/Products/ProductIssues/ProductIssue'
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductIssueState from '@/components/Products/ProductIssues/ProductIssueState.vue';
import ProductIssueStateEnum from '@/models/Products/ProductIssues/ProductIssueState';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import ProductPublishDialog from '@/components/Products/ProductIssues/ProductIssueCreateDialog.vue';
import OpenEntityInCurrentWindowLink from '@/components/Shared/OpenEntityInCurrentWindowLink.vue';
import PermissionType from '@/models/Settings/Roles/PermissionType';
import PermissionUtils from '@/lib/permissionUtils';
import PageRoutes from '@/router/PageRoutes';

@Component({ name: 'ProductIssues', components: { ProductIssueState, ProductPublishDialog, OpenEntityInCurrentWindowLink } })
export default class extends SaascadaVue {

    ProductIssueStateEnum = ProductIssueStateEnum;
    PageRoutes = PageRoutes;
    headers = [
        { text: this.$t('pageText.productIssues.fields.name'), sortable: false, width: "50%" },
        { text: this.$t('pageText.productIssues.fields.issueNumber'), sortable: false, width: "30%" },
        { text: this.$t('pageText.productIssues.fields.state'), sortable: false, width: "20%" },
    ];
    productIssuesPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.productIssuesPage = +page;
        }
    }

    async beforeMount() {
        await ProductDetailsModule.getProductIssues(this.productIssuesPage);
    }

    async getProductIssues() {
        // Refreshing takes you back to the first page incase there are new product issues to show
        await ProductDetailsModule.getProductIssues(1);
    }

    @Watch('productIssuesPage')
    async onProductIssuesPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.productIssuesPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.productIssuesPage}` } });
        }
        // Get new product issues
        await ProductDetailsModule.getProductIssues(this.productIssuesPage);
    }

    async updateCurrentProductIssue(productIssue: ProductIssue) {
        ProductDetailsModule.updateCurrentProductIssue(productIssue);
    }

    get currentProductIssue() {
        return ProductDetailsModule.currentProductIssue;
    }

    get totalProductIssuesPages() {
        return ProductDetailsModule.totalProductIssuesPages;
    }

    get loading() {
        return ProductDetailsModule.loadingProductIssues;
    }

    get pageSize() {
        return ProductDetailsModule.pageSize;
    }

    get productIssues() {
        return ProductDetailsModule.productIssues;
    }

    get showApproveCancelButtons() {
        if (this.currentProductIssue.state === ProductIssueStateEnum.Pending && PermissionUtils.hasPermission(PermissionType.ProductsManage)) {
            return true;
        }
        else {
            return false;
        }
    }

    async approve() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Approve",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to approve this product issue?', options);
        if (result) {
            await ProductDetailsModule.approveProductIssue();
            await ProductDetailsModule.getProduct(ProductDetailsModule.product.id);
        }
    }

    async cancel() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Yes",
            buttonFalseText: "No",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to cancel this product issue?', options);
        if (result) {
            await ProductDetailsModule.cancelProductIssue();
            await ProductDetailsModule.getProduct(ProductDetailsModule.product.id);
        }
    }

}
